import React from 'react'
import PropTypes from 'prop-types'

import { AudioDevices } from '../AudioDevices'
import { audioChatStartResponse } from '../../actions/media'
const stateProps = {
  'features.audioChat': PropTypes.bool.isRequired,
  'audio.chatRequest': PropTypes.bool.isRequired,
  'audio.requestByPeer': PropTypes.bool.isRequired,
  'audio.restartStatus.started': PropTypes.bool.isRequired,
  'mediaDevices.queryInProgress': PropTypes.bool.isRequired,
}

/**
 * check if this modal should be displayed
 * @param {Object} state - the whole store state
 * @returns {Boolean} - true|false
 */
const shouldDisplay = ({
  features: { audioChat: audioChatFeature },
  audio: {
    chatRequest,
    requestByPeer,
    restartStatus: {
      started: restartStarted,
    }
  }
}) => {
  return (audioChatFeature && chatRequest && requestByPeer && !restartStarted)
}

/**
 * returns the modal data; this function is called
 * by AppModal only when this modal should be displayed
 * @param {Object} state - store state
 * @param {Function} dispatch - store dispatch
 * @param {Function} translate - i18n.t
 *
 * @returns {Object} - the modal data to be rendered by AppModal
 */
const getModalData = ({
  state: {
    mediaDevices:
      { queryInProgress: mediaDevicesQueryInProgress }
  },
  dispatch,
  translate,
}) => {
  const buttons = [
    {
      text: 'chat-btn-accept',
      disabled: mediaDevicesQueryInProgress,
      onClick: () => dispatch(audioChatStartResponse({ fromPeer: false, response: true }))
    },
    {
      text: 'chat-btn-reject',
      disabled: mediaDevicesQueryInProgress,
      onClick: () => dispatch(audioChatStartResponse({ fromPeer: false, response: false }))
    },
  ]

  const body = <div>
    <p>{translate('chat-request-by-peer-text')}</p>
    <AudioDevices showMediaDevices={false} />
  </div>

  return {
    iconClass: 'modal-icon-audio-chat',
    title: 'chat-request-by-peer-title',
    body,
    buttons,
  }
}

export default {
  stateProps,
  shouldDisplay,
  getModalData,
}
